// The TrustPilot widget has an anchor that uses target='_blank' and
// rel='noopener'
/* eslint-disable react/jsx-no-target-blank */
import { noop } from 'lodash';
import React, { useEffect } from 'react';

const containerStyle = {
  minHeight: '13.5rem'
};

const imageContainerStyle = {
  margin: '2rem 2rem 0',
  pointerEvents: 'none'
};

const disclaimerStyle = {
  fontSize: '13px',
  margin: '0 2rem 0',
  textAlign: 'center'
};

function TrustPilotWidget() {
  useEffect(() => {
    const scriptId = 'trust-pilot-script';
    const existingScript = document.getElementById(scriptId);

    if (!existingScript) {
      const script = document.createElement('script');

      script.id = scriptId;
      script.src =
        'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }

    return noop;
  }, []);

  return (
    <div css={containerStyle}>
      <div
        className='trustpilot-widget'
        data-locale='en-US'
        data-template-id='53aa8807dec7e10d38f59f32'
        data-businessunit-id='52025de90000640005760d38'
        data-style-height='150px'
        data-style-width='100%'
        data-theme='light'
        css={imageContainerStyle}
      >
        <a
          href='https://www.trustpilot.com/review/opploans.com'
          target='_blank'
          rel='noopener'
        >
          Trustpilot
        </a>
      </div>
      <p css={disclaimerStyle}>
        Testimonials reflect the individual&apos;s opinion and may not be
        illustrative of all individual experiences with OppLoans.
      </p>
    </div>
  );
}

export default TrustPilotWidget;
